import { Record as record } from 'immutable';
import { construct, fields, resolve } from '../helpers/LinkMapper';
import { RAILCARD1617_CODE, Railcard1617States } from '../constants/AppConstants';
import config from '../config';
import trainTime from '../lib/TrainTime';

const defaults = {
    cardholderName: null,
    created: null,
    email: null,
    expired: null,
    expiryDate: null,
    firstName: null,
    id: null,
    isGuest: false,
    isPreferred: false,
    isSeason: false,
    lastName: null,
    railcardCode: '',
    railcardName: null,
    railcardNumber: null,
    seenRailcardApproved: null,
    seenSyncKeyGoNotification: null,
    state: null,
    syncedWithKeygo: false
};

class AccountRailcard extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(AccountRailcard, json, {
            cardholderName: fields.string,
            created: fields.datetime,
            email: fields.string,
            expired: fields.bool,
            expiryDate: fields.datetime,
            firstName: fields.string,
            id: fields.number,
            isGuest: fields.bool,
            isPreferred: fields.bool,
            isSeason: fields.bool,
            lastName: fields.string,
            railcardCode: resolve(json.railcardCode).with(data => data.code) || fields.string,
            railcardName: fields.string,
            railcardNumber: fields.string,
            seenRailcardApproved: fields.bool,
            seenSyncKeyGoNotification: fields.bool,
            state: fields.string,
            syncedWithKeygo: fields.bool
        });
    }

    getMaximumValidDate() {
        const railcard1617GracePeriod = config.get('railcard1617GracePeriod');

        if (this.expiryDate) {
            const maxValidDate = this.expiryDate.clone();
            return maxValidDate.add(railcard1617GracePeriod);
        } else {
            return trainTime('1970-01-01');
        }
    }

    isPresent() {
        const railcardCode = this.railcardCode || '';
        return railcardCode === RAILCARD1617_CODE;
    }

    isValid(testTodayDate = null) {
        const railcardCode = this.railcardCode || '';
        let isExpired = true;

        if (this.expiryDate) {
            const expiryDate = this.expiryDate.clone();
            const todayDate = testTodayDate ? testTodayDate : trainTime();

            if (todayDate.isSameOrBefore(expiryDate, 'days')) {
                isExpired = false;
            }
        }

        return this.get('state') === Railcard1617States.ACCEPTED
            && railcardCode === RAILCARD1617_CODE
            && !isExpired;
    }
}

export default AccountRailcard;



// WEBPACK FOOTER //
// ./src/records/AccountRailcard.js